module.exports = __webpack_public_path__ + "img/bg3.a4c53aac.png";